import { shouldLog } from 'common/support/Log';

interface ActionWithMetadata {
  type?: string;
  metadata?: {
    logType?: string;
  };
}

export const getActionLogType = (action: ActionWithMetadata): string => {
  const logType = action.metadata && action.metadata.logType;

  if (!logType) {
    return action.type && action.type.endsWith('_ERROR') ? 'ERROR' : 'INFO';
  }

  return logType;
};

export const shouldLogAction = (action: ActionWithMetadata): boolean => shouldLog(getActionLogType(action));
